//requires: public\EnhancedContent.js
/**
 * 
 */

L.EnhancedContent.Custom = L.EnhancedContent.extend({

	statics: {
		TYPE: "custom"
	},
	
	initialize: function(source, options){
		L.EnhancedContent.prototype.initialize.call(this,source, options);
				
	},
	
	getType: function(){
		return  L.EnhancedContent.Custom.TYPE;
	},
	
	getProperties(){
		return {'header':this._header,'content':this._content,'templateId':this._templateTarget};
	},
	
	setContent: function(content){
		this._content = content;
	},
	
	getContent: function(){
		return this._content;
	},
	
	setHeader(header){
		this._header = header;
	},

	getHeader: function(){
		return this._header;
	},
	
	setTemplateId: function(id){
		this._templateTarget = id;
		templatesManager.loadTemplate(this._templateTarget);
	},
	
	getTemplateId: function(){
		return this._templateTarget;
	},
	
	setModalHtmlId: function(htmlId){
		this._htmlModalId = htmlId;
	},
	
	

	toJSONable: function(){
		var jsonable= {};
		
		jsonable['type'] = this.getType();
		jsonable['header'] = this.getHeader();
		jsonable['content'] = this.getContent();
		jsonable['templateId'] = this.getTemplateId();
		
		return jsonable;
	}
	
})


L.EnhancedContent.custom = function (htmlId, options) {
    return new L.EnhancedContent.Custom(htmlId, options);
};


L.Popup.include({
	bindCustomEnhancedContent: function(content){
		if ((content instanceof L.EnhancedContent) && (content.getType() == L.EnhancedContent.Custom.TYPE)){
			this._enhancedContent = content;
			content._source = this;
			content._source._source.on('preclick',this.onCustomContentUpdate,content._source);
		}
	},
	
	onCustomContentUpdate: function(e){
		
		this.setContent(this.formatCustomContent());
	},
	
	unbindCustomEnhancedContent: function(){
		
		this._enhancedContent._source = undefined;
		unBinded = this._enhancedContent;
		this._enhancedContent = undefined;
		content._source._source.off('preclick',null,this);
		return 
	},
	
	formatCustomContent: function(){
		
		var templateToDisplayHtml = this._default_popup_template;
		
		jQuery(templateToDisplayHtml).find('.popup-body').html(decodeURIComponent(this._enhancedContent.getContent()));
		
		if (this._enhancedContent.getHeader()){
			var popupTitle = jQuery.parseHTML(decodeURIComponent(this._enhancedContent.getHeader()));
			jQuery(popupTitle).addClass('popup-title');
			jQuery(templateToDisplayHtml).find('.popup-title').replaceWith(popupTitle);	
		}
	
		return templateToDisplayHtml;
	}
	
});

L.Popup.addInitHook(function(){
	jQuery.get({
		url: ajax_object.ajaxurl,
		method: 'GET',
		data:{
			"action":"popup_parts",
			"id": "",
			"part": 'default',
			"destid": ""
		},
		context: this,
		success: function(data){
			this._default_popup_template = jQuery.parseHTML(data.html)[0];
		},
		dataType: "json"

	});
});

L.Modal.include({
	
	bindCustomEnhancedContent: function(content){
		if ((content instanceof L.EnhancedContent) && (content.getType() == L.EnhancedContent.Custom.TYPE)){
			this._enhancedContent = content;
			content._source = this;
			content._source._source.on('preclick',this.onCustomContentUpdate,content._source);
		}
	},
	
	onCustomContentUpdate: function(e){
		
		this._content = this.formatCustomContent();
		if (this._source.setContent){
			
			this._source.setContent(this._content);
		}
	},
	
	unbindCustomEnhancedContent: function(){
		
		this._enhancedContent._source = undefined;
		unBinded = this._enhancedContent;
		this._enhancedContent = undefined;
		content._source._source.off('preclick',null,this);
		return 
	},
	
	formatCustomContent: function(){
		
		var templateToDisplayHtml = this._default_modal_template;
		var newTemplate = jQuery(templateToDisplayHtml).filter('#htmlModalId').attr('id',(this._htmlModalId.substr(1, this._htmlModalId.length)));

		if(this.options.vertivalCentered){
			jQuery(templateToDisplayHtml).find('.modal-dialog').addClass('modal-dialog-centered');
		}
		
		if(!this.options.animated){
			jQuery(templateToDisplayHtml).find('.modal').removeClass('fade');
		}	

		if(this.options.width){
			
			switch (this.options.width){
			case 'small':
			{
				jQuery(templateToDisplayHtml).find('.modal-dialog').addClass('modal-sm');
				break;
			}
			case 'large':
			{
				jQuery(templateToDisplayHtml).find('.modal-dialog').addClass('modal-lg');
				break;
			}
			default:
			{
				jQuery(templateToDisplayHtml).find('.modal-dialog').removeClass('modal-sm');
				jQuery(templateToDisplayHtml).find('.modal-dialog').removeClass('modal-lg');
			}
			}
			
		}
		
		if(this.options.className){
			jQuery(templateToDisplayHtml).find('.modal-content').addClass(this.options.className);
		}

		
		jQuery(templateToDisplayHtml).find('.modal-body').html(decodeURIComponent(this._enhancedContent.getContent()));
		
		if (this._enhancedContent.getHeader()){
			var modalTitle = jQuery.parseHTML(decodeURIComponent(this._enhancedContent.getHeader()));
			jQuery(modalTitle).addClass('modal-title');
			jQuery(templateToDisplayHtml).find('.modal-title').replaceWith(modalTitle);	
		}
		
		return templateToDisplayHtml;
		
	}

});

L.Tooltip.include({
	bindCustomEnhancedContent: function(content){
		if ((content instanceof L.EnhancedContent) && (content.getType() == L.EnhancedContent.Custom.TYPE)){
			this._enhancedContent = content;
			content._source = this;
			
			jQuery.get({
				url: ajax_object.ajaxurl,
				method: 'GET',
				data:{
					"action":"tooltip_parts",
					"id": "",
					"part": 'default',
					"destid": ""
				},
				context: this,
				success: function(data){
					var templateToDisplayHtml = jQuery.parseHTML(data.html)[0];
					
					jQuery(templateToDisplayHtml).find('.tooltip-body').html(decodeURIComponent(this._enhancedContent.getContent()));
					
					if (this._enhancedContent.getHeader()){
						var tooltipTitle = jQuery.parseHTML(decodeURIComponent(this._enhancedContent.getHeader()));
						jQuery(tooltipTitle).addClass('tooltip-title');
						jQuery(templateToDisplayHtml).find('.tooltip-title').replaceWith(tooltipTitle);	
					}
					
					this.setContent(templateToDisplayHtml);
				},
				dataType: "json"

			});
		}
	},
	
	unbindCustomEnhancedContent: function(){
		
		this._enhancedContent._source = undefined;
		unBinded = this._enhancedContent;
		this._enhancedContent = undefined;
		return 
	},
	
});

